(function () {
  const cookiesLP = document.querySelector('#cookiesLP');
  const closeModal = (element) => {
    element.classList.remove('show');
  };

  if (cookiesLP) {
    const wasClicked = sessionStorage.getItem('popupWasClicked');
    if (wasClicked) {
      closeModal(cookiesLP);
    } else {
      document.querySelector('#btn-close-modal-cookiesLP').addEventListener('click', () => {
        sessionStorage.setItem('popupWasClicked', '1');
        closeModal(cookiesLP);
      });
    }
  }
}(document));
